export const ValidateUrl = (url) => {
  const urlHasDoubleBars = url.indexOf('//');
  if ( urlHasDoubleBars === -1 ) return false;

  const hasProtocol = url.split('//');
  if ( hasProtocol[0] !== "http:" && hasProtocol[0] !== "https:" ) return false;
  if ( hasProtocol[1].indexOf('.') === -1 ) return false;

  return true;
}